module.exports = __webpack_public_path__ + "img/index_szzy.5ab144df.svg";